<template>
    <div class="is-flex is-flex-direction-row is-align-items-center pt-2" style="gap: 1rem;" id="">
        <a href="https://www.facebook.com/Vetsolutionsmx/" target="_blank">
            <img src="@/assets/image/home/socialMedia/fb.png" alt="Facebook" class="social-img" />
        </a>
        <a href="https://www.instagram.com/vetsolutionsmx?igsh=ZjFjZjh3Y3doMTZ1" target="_blank">
            <img src="@/assets/image/home/socialMedia/insta.png" alt="Facebook" class="social-img" />
        </a>
        <!-- <a href="https://www.facebook.com/vetsolutions.cl" target="_blank">
            <img src="@/assets/image/home/whats.png" alt="Facebook" class="social-img" />
        </a> -->
    </div>
</template>

<script setup>

</script>
    
<style scoped> 
    .social-img{
        width: 25px;
        aspect-ratio: 1/1;
        object-fit: contain;
    }
</style>